import { useMutation } from '@occc-app/dataAccessLayer/utils';
import {
  GenerateKioskAssetUploadSignedUrlMutationOptions,
  useGenerateKioskAssetUploadSignedUrlMutation,
} from '@occc/graphql';

export const useGenerateKioskAssetUploadSignedUrl = (
  baseOptions?: GenerateKioskAssetUploadSignedUrlMutationOptions,
) => useMutation(useGenerateKioskAssetUploadSignedUrlMutation, baseOptions);
